import $ from 'jquery';
import SelectedJobsState from './SelectedJobsState';
import EventBus from '../../common/EventBus';

const SELECTORS = {
  footer: '.v2-booking-floating-footer',
  basket: '.v2-booking-floating-footer-basket',
  messageBox: '.v2-booking-floating-footer-message',
};

export default class MobileFooter {
  constructor() {
    this.footer = $(SELECTORS.footer);
    this.basket = $(SELECTORS.basket);
    this.messageBox = $(SELECTORS.messageBox);
    this.selectedJobsState = new SelectedJobsState();
    this._subscribeToEvents();
  }

  _subscribeToEvents() {
    EventBus.on('quote:fetching-start', () => this.startFetchingQuote());
    EventBus.on('quote:fetching-end', () => this.endFetchingQuote());
  }

  startFetchingQuote() {
    if (this.selectedJobsState.selectedJobs().length) {
      this.basket.removeClass('hidden');
      this.messageBox.addClass('hidden');
      this.footer.removeClass('hidden');
    } else {
      this.footer.addClass('hidden');
    }
  }

  endFetchingQuote() {
    if (!this.selectedJobsState.selectedJobs().length) {
      this.basket.addClass('hidden');
    }
  }
}
